<template>
  <!-- Begin Page Content -->
  <div class="container-fluid">
    <!-- Page Heading -->
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">Tableau de bord</h1>
    </div>
    <!-- Affichage d'erreur -->
    <div class="form-group">
      <div
        class="alert text-left formatted-text"
        :class="{
          'alert-danger': error,
        }"
        role="alert"
        v-show="error"
      >
        {{ this.error }}
      </div>
    </div>

    <div class="row">
      <!-- Earnings (Monthly) Card Example -->
      <div class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-primary shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div
                  class="text-sm font-weight-bold text-primary text-uppercase mb-1"
                >
                  total demandes
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">
                  {{ stat_numbers_state.TOTAL }}
                </div>
              </div>
              <div class="col-auto">
                <i class="fas fa-globe-africa fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Earnings (Monthly) Card Example -->
      <div class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-success shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div
                  class="text-sm font-weight-bold text-success text-uppercase mb-1"
                >
                  total e-Visas délivrés
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">
                  {{ stat_numbers_state.GENERATED }}
                </div>
              </div>
              <div class="col-auto">
                <i class="fas fa-check-double fa-2x text-gray-300"></i>
                <!-- <i class="fas fa-check-double"></i> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Pending Requests Card Example -->
      <div class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-warning shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div
                  class="text-sm font-weight-bold text-warning text-uppercase mb-1"
                >
                  total demandes en attente
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">
                  {{
                    stat_numbers_state.PROCESSING +
                      stat_numbers_state.VALIDATION
                  }}
                </div>
              </div>
              <div class="col-auto">
                <i class="fas fa-pause fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Pending Requests Card Example -->
      <!-- <div class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-warning shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div
                  class="text-sm font-weight-bold text-info text-uppercase mb-1"
                >
                  total demandes non payées
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">
                  {{ stat_numbers_state.NON_PAID }}
                </div>
              </div>
              <div class="col-auto">
                <i class="fas fa-money-check-alt fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- Pending Requests Card Example -->
      <div class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-info shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div
                  class="text-sm font-weight-bold text-info text-uppercase mb-1"
                >
                  total demandes validées
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">
                  {{ stat_handled }}
                </div>
              </div>
              <div class="col-auto">
                <i class="fas fa-money-check-alt fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-12 col-lg-12">
        <!-- Bar Chart -->
        <div class="card shadow mb-4">
          <!-- Card Header - Dropdown -->
          <div
            class="card-header py-3 d-flex flex-row align-items-center justify-content-between"
          >
            <h6 class="m-0 font-weight-bold text-primary">
              Détails des opérations de la journée du
              <code>{{ format_date(daily) }}</code>
            </h6>
            <div class="form-row">
              <label for="statut" class="mr-2">Statut:</label>
              <select
                id="statut"
                class="form-control col-8"
                v-model="daily_statut"
                name="statut"
              >
                <option value="">Sélectionnez...</option>
                <option v-for="s in DEMAND_STATUS" :value="s.value" :key="s.id">
                  {{ s.label }}
                </option>
              </select>
            </div>
          </div>

          <div class="card-body">
            <div class="chart-bar">
              <canvas id="myBarChart"></canvas>
            </div>
            <!-- <hr />
            Détails des opérations de la journée du
            <code>/js/demo/chart-bar-demo.js</code> . -->
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- Area Chart -->
      <div class="col-xl-8 col-lg-7">
        <div class="card shadow mb-4">
          <!-- Card Header - Dropdown -->
          <div
            class="card-header py-3 d-flex flex-row align-items-center justify-content-between"
          >
            <h6 class="m-0 font-weight-bold text-primary">
              Courbe d'évolution de la journée
            </h6>
            <!-- <div class="dropdown no-arrow">
              <a
                class="dropdown-toggle"
                href="#"
                role="button"
                id="dropdownMenuLink"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="fas fa-ellipsis-v fa-sm fa-fw text-gray-400"></i>
              </a>
              <div
                class="dropdown-menu dropdown-menu-right shadow animated--fade-in"
                aria-labelledby="dropdownMenuLink"
              >
                <div class="dropdown-header">Dropdown Header:</div>
                <a class="dropdown-item" href="#">Action</a>
                <a class="dropdown-item" href="#">Another action</a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="#">Something else here</a>
              </div>
            </div> -->
          </div>
          <!-- Card Body -->
          <div class="card-body">
            <div class="chart-area">
              <canvas id="myAreaChart"></canvas>
            </div>
          </div>
        </div>
      </div>

      <!-- Pie Chart -->
      <div class="col-xl-4 col-lg-5">
        <div class="card shadow mb-4">
          <!-- Card Header - Dropdown -->
          <div
            class="card-header py-3 d-flex flex-row align-items-center justify-content-between"
          >
            <h6 class="m-0 font-weight-bold text-primary">
              Top pays demandeurs d'e-Visa de la journée
            </h6>
            <!-- <div class="dropdown no-arrow">
              <a
                class="dropdown-toggle"
                href="#"
                role="button"
                id="dropdownMenuLink"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="fas fa-ellipsis-v fa-sm fa-fw text-gray-400"></i>
              </a>
              <div
                class="dropdown-menu dropdown-menu-right shadow animated--fade-in"
                aria-labelledby="dropdownMenuLink"
              >
                <div class="dropdown-header">Dropdown Header:</div>
                <a class="dropdown-item" href="#">Action</a>
                <a class="dropdown-item" href="#">Another action</a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="#">Something else here</a>
              </div>
            </div> -->
          </div>
          <!-- Card Body -->
          <div class="card-body">
            <div class="chart-pie pt-4 pb-2">
              <canvas id="myPieChart"></canvas>
            </div>
            <div class="mt-4 text-center small">
              <span
                class="mr-2"
                v-for="(v, index) in Object.keys(this.stat_top_countries)"
                :key="index"
              >
                <i
                  class="fas fa-circle"
                  :style="{ color: stat_top_countries_color[index] }"
                ></i>
                {{ v }}
              </span>
              <!-- <span class="mr-2">
                <i class="fas fa-circle text-primary"></i> Homme
              </span>
              <span class="mr-2">
                <i class="fas fa-circle text-info"></i> Femme
              </span> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /.container-fluid -->
</template>

<script>
import { mapGetters } from "vuex";

// import vSelect from "vue-select";
// import * as $ from "jquery"; // for datatable
import Chart from "chart.js";
import {
  FETCH_DEMANDS_STAT,
  FETCH_TOP_COUNTRIES_STAT,
  FETCH_MATCHEDS,
} from "@/store/actions.type";
import { DEMAND_STATUS } from "@/helpers/messages";
import { P_READ_DEMAND } from "@/helpers/permissions";

// import { P_READ_DEMAND } from "@/helpers/permissions";
// import { SET_LOADING } from "@/store/mutations.type";
// import {
//   FETCH_DEMANDS_REPORT,
//   FETCH_COUNTRIES,
//   FETCH_VISATYPES,
// } from "@/store/actions.type";
// import frLocalDatatable from "@/assets/french.json";

export default {
  components: {
    // vSelect,
  },
  data() {
    return {
      error: "",
      P_READ_DEMAND,
      demand_start_date: "",
      demand_end_date: "",
      arrival_start_date: "",
      arrival_end_date: "",
      departure_start_date: "",
      departure_end_date: "",
      birth_start_date: "",
      birth_end_date: "",
      nationality: "",
      birth_country: "",
      passport_country: "",
      visatype: "",
      statut: "",
      gender: "",
      from_office: "",
      daily: this.format_date(new Date(), "picker"),
      daily_statut: "",
      timer: "",

      statuts: [
        { id: 1, value: "GENERATED" },
        { id: 2, value: "PROCESSING" },
        { id: 3, value: "VALIDATION" },
      ],
      genders: [
        { id: 1, value: "male", label: "Masculin" },
        { id: 2, value: "female", label: "Féminin" },
      ],
      from_offices: [
        { id: 1, value: 1, label: "Oui" },
        { id: 2, value: 0, label: "Non" },
      ],
      // P_READ_DEMAND,
      more_criteria: false,
      stat_top_countries_color: [
        "#1cc88a",
        "#4e73df",
        "#36b9cc",
        "#a650b7",
        "#8e7070",
        "#e0ed8b",
        "#899bba",
        "#7c7b75",
        "#c371ce",
        "#828796",
      ],
      DEMAND_STATUS,
      myChartBar: null,
    };
  },
  async mounted() {
    // await this.getVisatypes();
    // await this.getCountries();
    //this.myBarChart();
    // this.myAreaChart();
    // this.myPieChart();
    this.getNumbersByState();
    this.getHandledDemandStat();
    this.getStatForDay();
    this.getMatchedDemands();
    // this.getStatForGender();
    this.getStatForTopCountries();

    this.timer = setInterval(this.updateDashboard, 300000);
  },
  computed: {
    ...mapGetters([
      "demandsr",
      "userPermissions",
      "visatypes",
      "countries",
      "stat_numbers_state",
      "stat_day",
      "stat_day_curve",
      "stat_gender",
      "stat_top_countries",
      "stat_handled",
    ]),
  },
  watch: {
    // daily: function () {
    //   this.getStatForDay();
    //   this.getNumbersByState();
    //   this.getStatForGender();
    // },
    daily_statut: function() {
      this.getStatForDay();
      this.getNumbersByState();
      // this.getStatForGender();
    },
  },
  methods: {
    // filterBy() {
    //   this.$store.commit(SET_LOADING, true);

    //   let params = {};
    //   if (this.demand_start_date) params.startdate = this.demand_start_date;
    //   if (this.demand_end_date) params.enddate = this.demand_end_date;
    //   if (this.arrival_start_date)
    //     params.startdate_arrival = this.arrival_start_date;
    //   if (this.arrival_end_date) params.enddate_arrival = this.arrival_end_date;
    //   if (this.departure_start_date)
    //     params.startdate_departure = this.departure_start_date;
    //   if (this.departure_end_date)
    //     params.enddate_departure = this.departure_end_date;
    //   if (this.birth_start_date)
    //     params.startdate_birthday = this.birth_start_date;
    //   if (this.birth_end_date) params.enddate_birthday = this.birth_end_date;
    //   if (this.gender) params.gender = this.gender;
    //   if (this.visatype) params.visatype = this.visatype;
    //   if (this.from_office) params.priority = this.from_office;
    //   if (this.nationality) params.nationality = this.nationality;
    //   if (this.birth_country) params.birth_country = this.birth_country;
    //   if (this.passport_country)
    //     params.passport_country = this.passport_country;

    //   if (this.statut) {
    //     params.state = this.statut;
    //   } else {
    //     params.state = "GENERATED,PROCESSING,VALIDATION,PENDING";
    //   }
    //   console.log(params);

    //   // On détruit le dataTable
    //   this.destroyDatatable();

    //   this.$store
    //     .dispatch(FETCH_DEMANDS_REPORT, params)
    //     .then(() => {
    //       // On réaffiche le dataTable
    //       // this.renderDatatable();
    //     })
    //     .catch(() => {
    //       // this.message.content = `${error} \n ${JSON.stringify(error.errors)}`;
    //     })
    //     .finally(() => {
    //       this.$store.commit(SET_LOADING, false);
    //       // datatable
    //       $(document).ready(function () {
    //         $("#dataTable").DataTable({
    //           language: frLocalDatatable,
    //         });
    //       });
    //     });
    // },
    // resetFilter() {
    //   this.demand_start_date = "";
    //   this.demand_end_date = "";
    //   this.arrival_start_date = "";
    //   this.arrival_end_date = "";
    //   this.departure_start_date = "";
    //   this.departure_end_date = "";
    //   this.birth_start_date = "";
    //   this.birth_end_date = "";
    //   this.nationality = "";
    //   this.birth_country = "";
    //   this.passport_country = "";
    //   this.visatype = "";
    //   this.statut = "";
    //   this.gender = "";
    //   this.from_office = "";
    // },

    // destroyDatatable() {
    //   let dt = $("#dataTable").DataTable();
    //   if (dt) {
    //     dt.destroy();
    //   }
    // },
    // generateReport() {
    //   this.$refs.html2Pdf.generatePdf();
    // },
    // handleCriteria() {
    //   this.more_criteria = !this.more_criteria;
    // },
    // getVisatypes() {
    //   this.$store.commit(SET_LOADING, true);
    //   this.$store
    //     .dispatch(FETCH_VISATYPES)
    //     .catch(() => {})
    //     .finally(() => {
    //       this.$store.commit(SET_LOADING, false);
    //     });
    // },
    // getCountries() {
    //   this.$store.commit(SET_LOADING, true);
    //   this.$store
    //     .dispatch(FETCH_COUNTRIES)
    //     .catch(() => {})
    //     .finally(() => {
    //       this.$store.commit(SET_LOADING, false);
    //     });
    // },
    getNumbersByState() {
      let params = {};
      params.stats = "1";
      params.startdate = this.daily + " 00:00";
      params.enddate = this.daily + " 23:59";
      let req = 1;

      this.$store
        .dispatch(FETCH_DEMANDS_STAT, { params, req })
        .catch((error) => {
          this.error = `${error}`;
          if (error.errors) {
            this.error += ` \n ${JSON.stringify(error.errors)} `;
          }
        });
    },
    getHandledDemandStat() {
      let params = {};
      params.stats = "1";
      params.startdate_issuing = this.daily + " 00:00";
      params.enddate_issuing = this.daily + " 23:59";
      params.state = "GENERATED";
      params.matched = "INTERPOL,REDLIST,GEN_AUTO";
      let req = 5;

      console.log("getHandledDemandStat....");

      this.$store
        .dispatch(FETCH_DEMANDS_STAT, { params, req })
        .catch((error) => {
          this.error = `${error}`;
          if (error.errors) {
            this.error += ` \n ${JSON.stringify(error.errors)} `;
          }
        });
    },
    getStatForDay() {
      let params = {};
      params.stats = "1";
      params.type = "5";
      params.startdate = this.daily + " 00:00";
      params.enddate = this.daily + " 23:59";
      if (this.daily_statut) params.state = this.daily_statut;
      let req = 2;

      this.$store
        .dispatch(FETCH_DEMANDS_STAT, { params, req })
        .then(() => {
          this.myBarChart();
          this.myAreaChart();
        })
        .catch((error) => {
          this.error = `${error}`;
          if (error.errors) {
            this.error += ` \n ${JSON.stringify(error.errors)} `;
          }
        });
    },
    getStatForGender() {
      let params = {};
      params.stats = "1";
      params.gender = "all";
      params.startdate = this.daily + " 00:00";
      params.enddate = this.daily + " 23:59";
      if (this.daily_statut) params.state = this.daily_statut;
      let req = 3;

      this.$store
        .dispatch(FETCH_DEMANDS_STAT, { params, req })
        .then(() => {
          this.myPieChart();
        })
        .catch((error) => {
          this.error = `${error}`;
          if (error.errors) {
            this.error += ` \n ${JSON.stringify(error.errors)} `;
          }
        });
    },
    getStatForTopCountries() {
      let params = {};
      params.startdate = this.daily + " 00:00";
      params.enddate = this.daily + " 23:59";

      params.top = 10;

      this.$store
        .dispatch(FETCH_TOP_COUNTRIES_STAT, params)
        .then(() => {
          this.myPieChart();
        })
        .catch((error) => {
          this.error = `${error}`;
          if (error.errors) {
            this.error += ` \n ${JSON.stringify(error.errors)} `;
          }
        });
    },
    myBarChart() {
      // Bar Chart Example
      let ctx = document.getElementById("myBarChart");
      if (this.myChartBar != null) {
        this.myChartBar.destroy();
      }
      this.myChartBar = new Chart(ctx, {
        type: "bar",
        data: {
          labels: [
            "1h",
            "2h",
            "3h",
            "4h",
            "5h",
            "6h",
            "7h",
            "8h",
            "9h",
            "10h",
            "11h",
            "12h",
            "13h",
            "14h",
            "15h",
            "16h",
            "17h",
            "18h",
            "19h",
            "20h",
            "21h",
            "22h",
            "23h",
            "24h",
          ],
          datasets: [
            {
              label: this.daily_statut ? this.daily_statut : "Demandes",
              backgroundColor: "#4e73df",
              hoverBackgroundColor: "#2e59d9",
              borderColor: "#4e73df",
              maxBarThickness: 25,
              data: this.stat_day,
            },
          ],
        },
        options: {
          maintainAspectRatio: false,
          layout: {
            padding: {
              left: 10,
              right: 25,
              top: 25,
              bottom: 0,
            },
          },
          scales: {
            xAxes: [
              {
                time: {
                  unit: "month",
                },
                gridLines: {
                  display: false,
                  drawBorder: false,
                },
                ticks: {
                  maxTicksLimit: 6,
                },
                // maxBarThickness: 25,
              },
            ],
            yAxes: [
              {
                ticks: {
                  min: 0,
                  max: Math.max(...this.stat_day),
                  maxTicksLimit: 5,
                  padding: 10,
                  // Include a dollar sign in the ticks
                  callback: function(value, index, values) {
                    index = values;
                    return value; //"$" + number_format(value);
                  },
                },
                gridLines: {
                  color: "rgb(234, 236, 244)",
                  zeroLineColor: "rgb(234, 236, 244)",
                  drawBorder: false,
                  borderDash: [2],
                  zeroLineBorderDash: [2],
                },
              },
            ],
          },
          legend: {
            display: false,
          },
          tooltips: {
            titleMarginBottom: 10,
            titleFontColor: "#6e707e",
            titleFontSize: 14,
            backgroundColor: "rgb(255,255,255)",
            bodyFontColor: "#858796",
            borderColor: "#dddfeb",
            borderWidth: 1,
            xPadding: 15,
            yPadding: 15,
            displayColors: false,
            caretPadding: 10,
            callbacks: {
              label: function(tooltipItem, chart) {
                var datasetLabel =
                  chart.datasets[tooltipItem.datasetIndex].label || "";
                return datasetLabel + ": " + tooltipItem.yLabel; // datasetLabel + ": $" + number_format(tooltipItem.yLabel);
              },
            },
          },
        },
      });
    },
    myAreaChart() {
      // Area Chart Example
      let ctx = document.getElementById("myAreaChart");
      new Chart(ctx, {
        type: "line",
        data: {
          labels: [
            "1h",
            "2h",
            "3h",
            "4h",
            "5h",
            "6h",
            "7h",
            "8h",
            "9h",
            "10h",
            "11h",
            "12h",
            "13h",
            "14h",
            "15h",
            "16h",
            "17h",
            "18h",
            "19h",
            "20h",
            "21h",
            "22h",
            "23h",
            "24h",
          ],
          datasets: [
            {
              label: "Nombre",
              lineTension: 0.3,
              backgroundColor: "rgba(78, 115, 223, 0.05)",
              borderColor: "rgba(78, 115, 223, 1)",
              pointRadius: 3,
              pointBackgroundColor: "rgba(78, 115, 223, 1)",
              pointBorderColor: "rgba(78, 115, 223, 1)",
              pointHoverRadius: 3,
              pointHoverBackgroundColor: "rgba(78, 115, 223, 1)",
              pointHoverBorderColor: "rgba(78, 115, 223, 1)",
              pointHitRadius: 10,
              pointBorderWidth: 2,
              data: this.stat_day_curve,
            },
          ],
        },
        options: {
          maintainAspectRatio: false,
          layout: {
            padding: {
              left: 10,
              right: 25,
              top: 25,
              bottom: 0,
            },
          },
          scales: {
            xAxes: [
              {
                time: {
                  unit: "date",
                },
                gridLines: {
                  display: false,
                  drawBorder: false,
                },
                ticks: {
                  maxTicksLimit: 7,
                },
              },
            ],
            yAxes: [
              {
                ticks: {
                  maxTicksLimit: 5,
                  padding: 10,
                  // Include a dollar sign in the ticks
                  callback: function(value, index, values) {
                    index = values;
                    return value;
                  },
                },
                gridLines: {
                  color: "rgb(234, 236, 244)",
                  zeroLineColor: "rgb(234, 236, 244)",
                  drawBorder: false,
                  borderDash: [2],
                  zeroLineBorderDash: [2],
                },
              },
            ],
          },
          legend: {
            display: false,
          },
          tooltips: {
            backgroundColor: "rgb(255,255,255)",
            bodyFontColor: "#858796",
            titleMarginBottom: 10,
            titleFontColor: "#6e707e",
            titleFontSize: 14,
            borderColor: "#dddfeb",
            borderWidth: 1,
            xPadding: 15,
            yPadding: 15,
            displayColors: false,
            intersect: false,
            mode: "index",
            caretPadding: 10,
            callbacks: {
              label: function(tooltipItem, chart) {
                var datasetLabel =
                  chart.datasets[tooltipItem.datasetIndex].label || "";
                return datasetLabel + ": " + tooltipItem.yLabel;
              },
            },
          },
        },
      });
    },
    myPieChart() {
      // Pie Chart Example
      let ctx = document.getElementById("myPieChart");
      new Chart(ctx, {
        type: "doughnut",
        data: {
          // labels: ["Homme", "Femme"],
          labels: Object.keys(this.stat_top_countries),
          datasets: [
            {
              // data: this.stat_gender,
              data: Object.values(this.stat_top_countries),
              backgroundColor: this.stat_top_countries_color,
              // hoverBackgroundColor: ["#2e59d9", "#17a673", "#2c9faf"],
              hoverBorderColor: "rgba(234, 236, 244, 1)",
            },
          ],
        },
        options: {
          maintainAspectRatio: false,
          tooltips: {
            backgroundColor: "rgb(255,255,255)",
            bodyFontColor: "#858796",
            borderColor: "#dddfeb",
            borderWidth: 1,
            xPadding: 15,
            yPadding: 15,
            displayColors: false,
            caretPadding: 10,
          },
          legend: {
            display: false,
          },
          cutoutPercentage: 80,
        },
      });
    },
    format_date(dateObj, format = "normal") {
      let month, day, year;

      if (format === "picker") {
        month = dateObj.getMonth() + 1;
        day = String(dateObj.getDate()).padStart(2, "0");
        year = dateObj.getFullYear();
        return year + "-" + month + "-" + day;
      }
      let par = dateObj.split("-");

      return par[2] + "/" + par[1] + "/" + par[0];
    },
    updateDashboard() {
      this.getNumbersByState();
      this.getHandledDemandStat();
      this.getStatForDay();
      this.getStatForTopCountries();
      this.getMatchedDemands();
    },

    getMatchedDemands() {
      //on execute pas s'il n'a pas le droit de lecture des demandes
      if (!this.userPermissions.some((e) => [this.P_READ_DEMAND].includes(e))) {
        return;
      }

      let params = {};

      params.page = 1;
      params.state = "PROCESSING,VALIDATION";
      params.matched = "INTERPOL,REDLIST";

      this.$store.dispatch(FETCH_MATCHEDS, params).catch((error) => {
        this.error = `${error}`;
        if (error.errors) {
          this.error += ` \n ${JSON.stringify(error.errors)} `;
        }
      });
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style lang="scss">
@import "vue-select/src/scss/vue-select.scss";
</style>

<style lang="scss" scoped>
@import "vue-select/src/scss/vue-select.scss";
.vs__dropdown-toggle {
  height: 38px;
}

.divTable {
  display: table;
  width: auto;
  background-color: #eee;
  border: 1px solid #666666;
  border-spacing: 5px; /*cellspacing:poor IE support for  this*/
  /* border-collapse:separate;*/
}

.divRow {
  display: table-row;
  width: auto;
}

.divCell {
  float: left; /*fix for  buggy browsers*/
  display: table-column;
  width: 200px;
  background-color: #ccc;
}

.form-row {
  display: flex;
  align-items: center;
}
label {
  margin-bottom: unset !important;
}
</style>
